import styled from 'styled-components';

const Group = styled.img`
	position: absolute;
	font-size: 14px;
	font-weight: 500;
	line-height: 22px;
	margin-left: -23.5px;
	z-index: 3;
`;

const Vector = styled.img`
	position: absolute;
	width: 64px;
	height: 13.896px;
	margin-top: 5px;
	margin-left: -32px;
	z-index: 0;
`;

const EmptyData: React.FC = () => (
	<div style={{ marginBottom: 20 }}>
		<Group src="/group-icon.svg" alt="" />
		<br />
		<Vector src="/vector-icon.svg" alt="" />
	</div>
);

export default EmptyData;
